import { Deg2Rad, circleRemainder } from "../../../math/MathEx.js";
import { J2000 } from "../../AstroConstants.js";
import { VondrakPrecessionAngles, } from "./VondrakPrecessionAngles.js";
import { Quaternion } from "../../../math/Quaternion.js";
import { TDBtoJD } from "../../AstroDate.js";
export class SEarthRotationModel {
    _lastAngles;
    _lastTdb;
    PrecessionUpdateInterval = 1.0;
    period = 23.9344694 / 24.0;
    IsPeriodic = true;
    computeSpin(tdb) {
        const jd = TDBtoJD(tdb);
        const ut1 = (jd - Math.floor(jd) + 0.5) * 86400.0;
        const t = (tdb - J2000) / 36525.0;
        const tu = (jd - J2000) / 36525.0;
        let sidereal = (((-0.000000002454 * t - 0.00000199708) * t - 0.0000002926) * t +
            0.09277211) *
            t *
            t;
        sidereal += (t - tu) * 307.4771013;
        sidereal += 8640184.79447825 * tu + 24110.5493771;
        sidereal += ut1;
        sidereal /= 240.0;
        sidereal = circleRemainder(sidereal * Deg2Rad);
        return Quaternion.YRotation(Math.PI - sidereal);
    }
    computeEquatorOrientation(tdb) {
        const angles = this.Precession(tdb);
        return Quaternion.YRotation(angles.psi).multiply(Quaternion.YRotation(-angles.chi).multiply(Quaternion.XRotation(angles.omega)));
    }
    Precession(tdb) {
        if (this._lastAngles &&
            this._lastTdb &&
            Math.abs(tdb - this._lastTdb) <= this.PrecessionUpdateInterval)
            return this._lastAngles;
        this._lastAngles = VondrakPrecessionAngles.Calculate(tdb);
        this._lastTdb = tdb;
        return this._lastAngles;
    }
}
